const $ = require('jquery');

const $button = $('.scroll-to-top__button'),
    classButtonVisible = 'scroll-to-top__button--visible';

$(window).on('scroll', function () {
    let scrolledDistance = $(document).scrollTop(),
        showTrigger = viewport().height,
        hideTrigger = $(document).outerHeight() - $('.footer-main').outerHeight() - viewport().height;

    if (scrolledDistance > showTrigger && scrolledDistance < hideTrigger) {

        if (!$button.hasClass(classButtonVisible)) {
            $button.addClass(classButtonVisible);
        }

    } else {
        if ($button.hasClass(classButtonVisible)) {
            $button.removeClass(classButtonVisible);
        }
    }
});

$button.on('click', function (e) {
    e.preventDefault();

    // https://stackoverflow.com/questions/29760049/scroll-to-next-section

    var target = 0;
    var topbarOffset = $('header[role="masthead"] .top-bar').outerHeight();

    // check if there are sections to pass before going to the top
    var y = $('section').filter( function (i, el) {
        return el.getBoundingClientRect().top > 0;
    })["prev"]('section').offset().top;

    if (typeof y !== "undefined" && y > 0) {
        target = y - topbarOffset + 1;
    }

    $('html, body').stop().animate({
        scrollTop: target
    }, 1000, 'easeInOutCubic', function () {
        $button.blur();
    });
});